import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-1ed15f78"), n = n(), _popScopeId(), n);
const _hoisted_1 = { key: 0 };
import { computed } from "vue";
export default /*#__PURE__*/ _defineComponent({
    name: 'index',
    props: {
        name: { default: "" },
        showName: { type: Boolean, default: true },
        border: { type: Boolean, default: false },
        baseSize: { default: 8 },
        length: { default: 1 },
        borderRadius: { default: 8 },
        showNickname: { type: Boolean, default: true },
        avatar: { default: "" }
    },
    setup(__props) {
        const props = __props;
        const getName = computed(() => {
            const name = props.name.trim();
            return props.length === 1
                ? name.slice(0, props.length).toUpperCase()
                : name.slice(0, props.length);
        });
        const getAvatar = computed(() => {
            const url = props.avatar
                ? props.avatar
                : "https://img.ebtech.com/avatars/default.png";
            return url;
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: "cloud-avatar",
                style: _normalizeStyle({
                    '--avatar-font-size': __props.baseSize + 'px',
                    '--avatar-volume-size': __props.baseSize * 2 + 'px',
                    '--avatar-border-radius': __props.borderRadius + 'px'
                })
            }, [
                _createElementVNode("div", {
                    class: "img-box",
                    style: _normalizeStyle({
                        border: __props.border ? '1px solid #fff' : 'none',
                        background: 'center no-repeat url(' + _unref(getAvatar) + ')',
                        backgroundSize: 'cover'
                    })
                }, _toDisplayString(__props.showNickname ? _unref(getName) : ""), 5),
                (__props.showName)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(__props.name), 1))
                    : _createCommentVNode("", true)
            ], 4));
        };
    }
});
